import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { parseSafe } from '../../../utils/HtmlUtil';

function ValuePropBanner(props) {
    const { show, okc } = props;

    if (!show) return null;

    const { copy } = props;

    return (
        <div className={cn('value-prop-banner', { okc })}>
            <p>
                {parseSafe(copy)}
            </p>
        </div>
    );
}

ValuePropBanner.propTypes = {
    show: PropTypes.bool.isRequired,
    copy: PropTypes.string.isRequired,
    okc: PropTypes.bool
};

ValuePropBanner.defaultProps = {
    okc: false
};

export default ValuePropBanner;
